import React, {useEffect} from "react";
import useSexType from "../Stores/SexStore";
interface SexProps {
  displayValue: number;
  id?: string;
}
const SexMenu: React.FC<SexProps> = ({displayValue, id}): JSX.Element => {
  const sexValue = useSexType((state) => state.sexValue);
  const setSexValue = useSexType((state) => state.setSexValue);
  const disabledSex = useSexType((state) => state.disabledSex);
  const sexList = useSexType((state) => state.sexList);

  useEffect(() => {}, [displayValue]);

  return (
    <select
      id={id}
      className={`text-center lg:text-center px-1 xl:select xl:select-bordered text-[12px]  bg-[#E5DCDD] appearance-none focus:outline-none focus:ring-0 focus:border-transparent ${
        disabledSex ? "text-gray-400 opacity-60 cursor-not-allowed" : ""
      }`}
      defaultValue={sexValue}
      onChange={(event) => setSexValue(Number(event.target.value))}
      disabled={disabledSex}>
      {sexList.map((label, index) => (
        <option key={index} value={index}>
          {label}
        </option>
      ))}
    </select>
  );
};

export default SexMenu;
